export default "__VITE_ASSET__83950c7a__"